import api from '@/api/dy/market.js'
const state = {
}
const mutations = {
}
const actions = {
	activeList({}, params = {}) {
        return api.activeList(params)
    },
    activeAdd({}, params = {}) {
        return api.activeAdd(params)
    },
    productSelect({}, params = {}) {
        return api.productSelect(params)
    },
    activeDel({}, params = {}) {
        return api.activeDel(params)
    },
    activeSurplus({}, params = {}) {
        return api.activeSurplus(params)
    },
    getBindedDyListAPI({}, params = {}) {
        return api.getBindedDyListAPI(params)
    },
    updateDyAccountAPI({}, params = {}) {
        return api.updateDyAccountAPI(params)
    },
    getDyWorksListAPI({}, params = {}) {
        return api.getDyWorksListAPI(params)
    },
    mountMiniVideoAPI({}, params = {}) {
        return api.mountMiniVideoAPI(params)
    },
}
export default {
	namespaced:true,
	state,
	mutations,
	actions,
}